import React from "react";
import { FiBookOpen } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "../BibleDisplay.css";
import InteractivePassage from "../bible/InteractivePassage";

const versions = ["ESV", "KRV", "NIV", "NLT", "SAE", "ABB"];

const NEU_RAISED_MD =
  "shadow-[-8px_-8px_18px_var(--outer-shadow-light),8px_8px_18px_var(--outer-shadow-dark)]";
const NEU_INSET_SM =
  "shadow-[inset_2px_2px_4px_var(--shadow-dark),inset_-2px_-2px_4px_var(--shadow-light)]";

const PassageReader = ({ passage, verses, version, onVersionChange, user, onRequireLogin }) => {
  const { i18n } = useTranslation();
  if (!passage) return null;

  const language = i18n.language?.startsWith("ko") ? "ko" : "en";
  // Show only the reference in the currently-active language; fall back to the
  // other if the primary is missing so the header never renders empty.
  const primaryRef =
    language === "ko"
      ? passage.reference_ko || passage.reference_en
      : passage.reference_en || passage.reference_ko;

  return (
    <section
      className={`rounded-[28px] p-[26px_24px] min-[601px]:rounded-[2rem] min-[601px]:p-space-lg md:p-space-xl bg-canvas-base ${NEU_RAISED_MD}`}
    >
      <div className="flex flex-col gap-space-md sm:flex-row sm:items-start sm:justify-between">
        <div className="flex flex-col gap-space-xs min-w-0">
          <span className="text-label-sm uppercase tracking-widest text-accent-gold-deep font-bold">
            Today’s Passage
          </span>
          {/* Mobile: single-language reference, responsive size. */}
          <h1
            className="font-noto-serif text-neu-primary min-[601px]:hidden"
            style={{
              fontSize:
                language === "ko" ? "clamp(2rem, 9vw, 2.55rem)" : "clamp(1.75rem, 8vw, 2.25rem)",
              lineHeight: 1.12,
              overflowWrap: "break-word",
            }}
          >
            {primaryRef}
          </h1>
          {/* Desktop / tablet: single-line header, same active language. */}
          <h1 className="hidden min-[601px]:block font-noto-serif text-headline-lg text-neu-primary">
            {primaryRef}
          </h1>
        </div>
        <label
          className={`inline-flex items-center gap-space-sm h-11 pl-4 pr-2 rounded-full bg-canvas-base ${NEU_INSET_SM} text-label-md text-slate-muted`}
        >
          <FiBookOpen aria-hidden="true" className="text-accent-gold-deep" />
          <span className="text-neu-primary font-semibold">Bible</span>
          <select
            value={version}
            onChange={(event) => onVersionChange(event.target.value)}
            className="h-9 rounded-full bg-white px-3 text-sm text-neu-primary font-semibold border-none outline-none focus:ring-2 focus:ring-[color:var(--accent-cta)]/30"
          >
            {versions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="mt-space-lg">
        <InteractivePassage
          verses={verses}
          version={version}
          user={user}
          actions={["memo", "highlight", "copy"]}
          onRequireLogin={onRequireLogin}
        />
      </div>
    </section>
  );
};

export default PassageReader;
